import { ILocalizer } from "../../Core/Localization/ILocalizer";

import { engineLocalizationDictionary } from "./localizationDictionary";

interface Dictionary {
    [id: string]: string;
}

export interface LocalizationDictionary {
    [lang: string]: Dictionary;
}

export class Localization implements ILocalizer {
    private readonly dictionary: Dictionary;
    private readonly defaultDictionary: Dictionary;

    public constructor(lang: undefined | string, localizationDictionary: LocalizationDictionary = {}) {
        const engineDictionary = lang ? engineLocalizationDictionary[lang] || {} : {};
        const formDictionary = lang ? localizationDictionary[lang] || {} : {};
        this.dictionary = { ...engineDictionary, ...formDictionary };
        this.defaultDictionary = localizationDictionary.default || {};
    }

    public translate = (message: string): string => {
        if (Object.prototype.hasOwnProperty.call(this.dictionary, message)) {
            const dictionaryMessage = this.dictionary[message];
            if (dictionaryMessage != undefined) {
                return dictionaryMessage;
            }
        }
        if (Object.prototype.hasOwnProperty.call(this.defaultDictionary, message)) {
            const defaultDictionaryMessage = this.defaultDictionary[message];
            if (defaultDictionaryMessage != undefined) {
                return defaultDictionaryMessage;
            }
        }
        return message;
    };
}
